import { Modal } from "antd";
import { ReactNode } from "react";

export function useConfirmModal() {
    const showConfirm = (
        content: ReactNode,
        okText: string,
        okType: "primary" | "danger" = "primary",
        onOk?: () => void
    ) => {
        Modal.confirm({
            width: 400,
            content,
            okText,
            okType,
            okButtonProps: { style: { borderRadius: 8, padding: '4px 20px' } },
            cancelText: 'Cancel',
            cancelButtonProps: { style: { borderRadius: 8, padding: '4px 20px' } },
            centered: true,
            icon: null,
            onOk
        });
    };

    return { showConfirm };
}
